import styled from 'styled-components'

export default styled(({ noBorder, ...props }) => (
  <div {...props} />
))`
  width: 100%;
  border-top: ${props => (props.noBorder ? '0' : `1px solid${props.theme.table.rowBorderColor}`)};
`
